import React from "react";
import Utils from "@/utils/index";
import { ReactComponent as VideoIcon } from "@/assets/icons/video.svg";
import { ReactComponent as CloseIcon } from "@/assets/icons/close.svg";
import Process from "@/components/common/process/Process";

import "@/assets/videoMute.less";


const VideoMuteWorkContentRender = ({ submitting, videoMuteObj, processText, cancelProcess }) => {
 
  return (
    <div className="work-cont-cont">
      <div className="work-cont-hd">
        <div style={{ display: "flex", alignItems: "center" }}>
          <VideoIcon />
          <span>{Utils.omissionString(videoMuteObj.name, 5, 5)}</span>
          <span>{(videoMuteObj.size / 1024 / 1024).toFixed(2)}MB</span>
        </div>
        <CloseIcon style={{ cursor: "pointer" }} onClick={cancelProcess} />
      </div>
      {submitting ? (
        <div className="work-cont-con" style={{ position: "relative", minHeight: 400 }}>
          <Process visible theme="dark" showProcessText processText={processText} hideCancelText hideCancelBtn />
        </div>
      ) : null}
    </div>
  );
};

export default VideoMuteWorkContentRender;
